<template>
  <div>
  <!-- <button v-on:click="this.$router.push('/yzPage')">跳转</button> -->
  <mainPage></mainPage>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import NewZj from "./components/NewZj.vue";
import mainPage from './components/mainPage.vue'
export default {
  name: 'App',
  components: {
    // HelloWorld
    // NewZj,
    mainPage
  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px;/ */
}
</style>
